import { render, staticRenderFns } from "./CompanionCondition.vue?vue&type=template&id=16087bc2&"
import script from "./CompanionCondition.vue?vue&type=script&lang=js&"
export * from "./CompanionCondition.vue?vue&type=script&lang=js&"
import style0 from "./CompanionCondition.vue?vue&type=style&index=0&id=16087bc2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports